/* eslint-disable no-undef */
export default {
    apiDomain: appConfig.VUE_APP_API_DOMAIN || process.env.VUE_APP_API_DOMAIN,
    minSumConfirming: appConfig.VUE_APP_MIN_SUM_CONFIRMING || process.env.VUE_APP_MIN_SUM_CONFIRMING,
    boxberryDeliveryTypeId: 1,
    sdekDeliveryTypeId: 2,
    postDeliveryTypeId: 3,
    courierDeliveryServiceMethod: 1,
    pvzDeliveryServiceMethod: 2,
    postDeliveryServiceMethod: 3,
    yandexDeliveryTracknumSearchTypeId: 7,
    mainColor: process.env.VUE_APP_MAIN_COLOR || '#3B90D1',
    urlHelp: appConfig.VUE_APP_URL_HELP || process.env.VUE_APP_URL_HELP,
    urlSupport: appConfig.VUE_APP_URL_SUPPORT || process.env.VUE_APP_URL_SUPPORT,
    loginKey: appConfig.VUE_APP_LOGIN_KEY || process.env.VUE_APP_LOGIN_KEY,
    env: appConfig.VUE_APP_ENV || process.env.VUE_APP_ENV,
    envName: appConfig.VUE_APP_ENV_NAME || process.env.VUE_APP_ENV_NAME,
    keycloak: {
        checkLoginIframe: !!(appConfig.VUE_APP_ENV_NAME || process.env.VUE_APP_ENV_NAME),
        url: (appConfig.VUE_APP_KEYCLOAK_URL || process.env.VUE_APP_KEYCLOAK_URL),
        realm: (appConfig.VUE_APP_KEYCLOAK_REALM || process.env.VUE_APP_KEYCLOAK_REALM),
        clientId: (appConfig.VUE_APP_KEYCLOAK_CLIENT_ID || process.env.VUE_APP_KEYCLOAK_CLIENT_ID),
        updateTokenMinValidity: 70,
    },
};